import { useMutation } from '@tanstack/react-query';

import { apiRequest } from 'src/helpers/apiRequest';
import { useAppConfig } from 'src/hooks';
import { SendInvitationsRequest } from 'src/types/rest/managementPortalApi';

export const useSendInvitations = () => {
  const {
    managementPortalApi: { apiHost },
  } = useAppConfig();

  return useMutation({
    mutationFn: (variables: SendInvitationsRequest) =>
      apiRequest<void>({
        data: variables,
        method: 'POST',
        url: `${apiHost}/invitations/send`,
      }),
  });
};
